import enFlag from 'assets/icons/ic_en_flag.svg';
import vnFlag from 'assets/icons/ic_vn_flag.svg';
import { MenuItemDataTypes } from 'services/menus/types';

const headerData: MenuItemDataTypes[] = [
  {
    id: 571,
    menuId: 3,
    title: 'Về VCBS',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 1,
    cssClass: 'menu-about',

    target: '_self',
    parentId: 2,
    lft: 788,
    rgt: 799,
    depth: 1,
    createdAt: '2021-12-06T09:29:08.747000Z',
    updatedAt: '2021-12-06T15:23:06.993000Z',
    reference: {
      slug: 'tong-quan',
    },
  },
  {
    id: 572,
    menuId: 3,
    title: 'Giới thiệu chung',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 2,

    target: '_self',
    parentId: 571,
    lft: 789,
    rgt: 790,
    depth: 2,
    createdAt: '2021-12-06T09:29:08.777000Z',
    updatedAt: '2021-12-06T09:29:08.807000Z',
    reference: {
      slug: 'gioi-thieu-chung',
    },
  },
  {
    id: 573,
    menuId: 3,
    title: 'Giá trị cốt lõi',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 4,

    target: '_self',
    parentId: 571,
    lft: 791,
    rgt: 792,
    depth: 2,
    createdAt: '2021-12-06T09:29:08.810000Z',
    updatedAt: '2021-12-06T09:29:08.830000Z',
    reference: {
      slug: 'gia-tri-cot-loi',
    },
  },
  {
    id: 574,
    menuId: 3,
    title: 'Thành tựu',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 3,

    target: '_self',
    parentId: 571,
    lft: 793,
    rgt: 794,
    depth: 2,
    createdAt: '2021-12-06T09:29:08.837000Z',
    updatedAt: '2021-12-06T09:29:08.863000Z',
    reference: {
      slug: 'thanh-tuu',
    },
  },
  {
    id: 575,
    menuId: 3,
    title: 'Sơ đồ tổ chức',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 5,

    target: '_self',
    parentId: 571,
    lft: 795,
    rgt: 796,
    depth: 2,
    createdAt: '2021-12-06T09:29:08.867000Z',
    updatedAt: '2021-12-06T09:29:08.897000Z',
    reference: {
      slug: 'so-do-to-chuc',
    },
  },
  {
    id: 576,
    menuId: 3,
    title: 'Mạng lưới hoạt động',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 6,

    target: '_self',
    parentId: 571,
    lft: 797,
    rgt: 798,
    depth: 2,
    createdAt: '2021-12-06T09:29:08.900000Z',
    updatedAt: '2021-12-06T09:29:08.933000Z',
    reference: {
      slug: 'mang-luoi-hoat-dong',
    },
  },
  {
    id: 577,
    menuId: 3,
    title: 'Khách hàng cá nhân',
    link: 'https://www.google.com.vn',
    type: 'custom_link',

    cssClass: 'menu-ic',

    target: '_blank',
    parentId: 2,
    lft: 800,
    rgt: 815,
    depth: 1,
    createdAt: '2021-12-06T09:29:08.940000Z',
    updatedAt: '2021-12-06T15:20:30.490000Z',
  },
  {
    id: 578,
    menuId: 3,
    title: 'Bảng giá trực tuyến',
    link: 'https://priceboard.vcbs.com.vn',
    type: 'custom_link',

    target: '_blank',
    parentId: 577,
    lft: 801,
    rgt: 802,
    depth: 2,
    createdAt: '2021-12-06T09:29:08.973000Z',
    updatedAt: '2021-12-06T09:29:08.997000Z',
  },
  {
    id: 579,
    menuId: 3,
    title: 'Giao dịch chứng khoán',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 10,

    target: '_self',
    parentId: 577,
    lft: 803,
    rgt: 804,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.003000Z',
    updatedAt: '2021-12-06T09:29:09.027000Z',
    reference: {
      slug: 'giao-dich-chung-khoan',
    },
  },
  {
    id: 580,
    menuId: 3,
    title: 'Hỗ trợ tài chính',

    type: 'OneContent\\KHCN\\Models\\Service',
    referenceId: 4,

    target: '_self',
    parentId: 577,
    lft: 805,
    rgt: 806,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.030000Z',
    updatedAt: '2021-12-06T09:29:09.057000Z',
    reference: {
      slug: 'ho-tro-tai-chinh',
    },
  },
  {
    id: 581,
    menuId: 3,
    title: 'Chứng quyền có đảm bảo',

    type: 'OneContent\\KHCN\\Models\\Service',
    referenceId: 5,

    target: '_self',
    parentId: 577,
    lft: 807,
    rgt: 808,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.060000Z',
    updatedAt: '2021-12-06T09:29:09.080000Z',
    reference: {
      slug: 'chung-quyen-co-dam-bao',
    },
  },
  {
    id: 582,
    menuId: 3,
    title: 'Phân phối Chứng chỉ Quỹ',

    type: 'OneContent\\KHCN\\Models\\ServiceCategory',
    referenceId: 7,

    target: '_self',
    parentId: 577,
    lft: 809,
    rgt: 810,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.087000Z',
    updatedAt: '2021-12-06T09:29:09.127000Z',
    reference: {
      slug: 'phan-phoi-chung-chi-quy',
    },
  },
  {
    id: 583,
    menuId: 3,
    title: 'Trái phiếu doanh nghiệp',

    type: 'OneContent\\KHCN\\Models\\ServiceCategory',
    referenceId: 8,

    target: '_self',
    parentId: 577,
    lft: 811,
    rgt: 812,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.130000Z',
    updatedAt: '2021-12-06T09:29:09.160000Z',
    reference: {
      slug: 'trai-phieu-doanh-nghiep',
    },
  },
  {
    id: 584,
    menuId: 3,
    title: 'Quản lý chứng khoán',

    type: 'OneContent\\KHCN\\Models\\Service',
    referenceId: 8,

    target: '_self',
    parentId: 577,
    lft: 813,
    rgt: 814,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.167000Z',
    updatedAt: '2021-12-06T09:29:09.200000Z',
    reference: {
      slug: 'quan-ly-chung-khoan',
    },
  },
  {
    id: 585,
    menuId: 3,
    title: 'Khách hàng tổ chức',

    type: 'custom_link',

    cssClass: 'menu-oc',

    target: '_self',
    parentId: 2,
    lft: 816,
    rgt: 835,
    depth: 1,
    createdAt: '2021-12-06T09:29:09.203000Z',
    updatedAt: '2021-12-06T15:22:08.437000Z',
  },
  {
    id: 586,
    menuId: 3,
    title: 'Ngân hàng đầu tư',

    type: 'custom_link',

    target: '_self',
    parentId: 585,
    lft: 817,
    rgt: 824,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.233000Z',
    updatedAt: '2021-12-06T09:29:09.347000Z',
  },
  {
    id: 587,
    menuId: 3,
    title: 'Tư vấn Mua bán sáp nhập/Tái cấu trúc doanh nghiệp',

    type: 'OneContent\\NHDT\\Models\\Service',
    referenceId: 1,

    target: '_self',
    parentId: 586,
    lft: 818,
    rgt: 819,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.277000Z',
    updatedAt: '2021-12-06T09:29:09.310000Z',
    reference: {
      slug: 'tu-van-mua-ban-sap-nhap',
    },
  },
  {
    id: 588,
    menuId: 3,
    title: 'Bảo lãnh phát hành / đại lý phát hành chứng khoán',
    type: 'OneContent\\NHDT\\Models\\Service',
    referenceId: 2,
    target: '_self',
    parentId: 586,
    lft: 820,
    rgt: 821,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.317000Z',
    updatedAt: '2021-12-06T09:29:09.337000Z',
    reference: {
      slug: 'bao-lanh-phat-hanh',
    },
  },
  {
    id: 589,
    menuId: 3,
    title: 'Các thương vụ thực hiện gần đây',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 25,

    target: '_self',
    parentId: 586,
    lft: 822,
    rgt: 823,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.343000Z',
    updatedAt: '2021-12-06T09:29:09.383000Z',
    reference: {
      slug: 'cac-thuong-vu-thuc-hien-gan-day',
    },
  },
  {
    id: 590,
    menuId: 3,
    title: 'Khách hàng tổ chức',

    type: 'custom_link',

    target: '_self',
    parentId: 585,
    lft: 825,
    rgt: 834,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.387000Z',
    updatedAt: '2021-12-06T09:29:09.563000Z',
  },
  {
    id: 591,
    menuId: 3,
    title: 'DỊCH VỤ CHỨNG KHOÁN',

    type: 'OneContent\\KHTC\\Models\\Service',
    referenceId: 1,

    target: '_self',
    parentId: 590,
    lft: 826,
    rgt: 827,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.413000Z',
    updatedAt: '2021-12-06T09:29:09.457000Z',
    reference: {
      slug: 'dich-vu-chung-khoan-khtc',
    },
  },
  {
    id: 592,
    menuId: 3,
    title: 'DỊCH VỤ TIẾP XÚC DOANH NGHIỆP',

    type: 'OneContent\\KHTC\\Models\\Service',
    referenceId: 2,

    target: '_self',
    parentId: 590,
    lft: 828,
    rgt: 829,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.463000Z',
    updatedAt: '2021-12-06T09:29:09.500000Z',
    reference: {
      slug: 'dich-vu-tiep-xuc-doanh-nghiep',
    },
  },
  {
    id: 593,
    menuId: 3,
    title: 'BÁO CÁO PHÂN TÍCH',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 24,

    target: '_self',
    parentId: 590,
    lft: 830,
    rgt: 831,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.503000Z',
    updatedAt: '2021-12-06T09:29:09.533000Z',
    reference: {
      slug: 'bao-cao-phan-tich',
    },
  },
  {
    id: 594,
    menuId: 3,
    title: 'ĐẶT LỆNH',

    type: 'OneContent\\KHTC\\Models\\Service',
    referenceId: 3,

    target: '_self',
    parentId: 590,
    lft: 832,
    rgt: 833,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.557000Z',
    updatedAt: '2021-12-06T09:29:09.597000Z',
    reference: {
      slug: 'dat-lenh',
    },
  },
  {
    id: 595,
    menuId: 3,
    title: 'Trung tâm phân tích',
    link: '/trung-tam-phan-tich',
    type: 'custom_link',

    target: '_self',
    parentId: 2,
    lft: 836,
    rgt: 837,
    depth: 1,
    createdAt: '2021-12-06T09:29:09.603000Z',
    updatedAt: '2021-12-06T09:29:09.633000Z',
  },
  {
    id: 596,
    menuId: 3,
    title: 'Hỗ trợ giao dịch',

    type: 'custom_link',

    cssClass: 'menu-ts',

    target: '_self',
    parentId: 2,
    lft: 838,
    rgt: 851,
    depth: 1,
    createdAt: '2021-12-06T09:29:09.637000Z',
    updatedAt: '2021-12-06T15:22:50.693000Z',
  },
  {
    id: 597,
    menuId: 3,
    title: 'Biểu phí',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 26,

    target: '_self',
    parentId: 596,
    lft: 839,
    rgt: 844,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.660000Z',
    updatedAt: '2021-12-06T09:29:09.723000Z',
    reference: {
      slug: 'bieu-phi',
    },
  },
  {
    id: 598,
    menuId: 3,
    title: 'Biểu phí phái sinh',

    type: 'OneContent\\HTGD\\Models\\Fee',
    referenceId: 6,

    target: '_self',
    parentId: 597,
    lft: 840,
    rgt: 841,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.687000Z',
    updatedAt: '2021-12-06T09:29:09.713000Z',
    reference: {
      slug: 'bieu-phi-phai-sinh',
    },
  },
  {
    id: 599,
    menuId: 3,
    title: 'Biểu phí cơ sở',

    type: 'OneContent\\HTGD\\Models\\Fee',
    referenceId: 5,

    target: '_self',
    parentId: 597,
    lft: 842,
    rgt: 843,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.720000Z',
    updatedAt: '2021-12-06T09:29:09.760000Z',
    reference: {
      slug: 'bieu-phi-co-so',
    },
  },
  {
    id: 600,
    menuId: 3,
    title: 'Hướng dẫn về hệ thống giao dịch',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 22,

    target: '_self',
    parentId: 596,
    lft: 845,
    rgt: 846,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.767000Z',
    updatedAt: '2021-12-06T09:29:09.810000Z',
    reference: {
      slug: 'huong-dan-ve-he-thong-giao-dich',
    },
  },
  {
    id: 601,
    menuId: 3,
    title: 'Hướng dẫn về sản phẩm, dịch vụ',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 23,

    target: '_self',
    parentId: 596,
    lft: 847,
    rgt: 848,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.813000Z',
    updatedAt: '2021-12-06T09:29:09.840000Z',
    reference: {
      slug: 'huong-dan-ve-san-pham-dich-vu-1',
    },
  },
  {
    id: 602,
    menuId: 3,
    title: 'Câu hỏi thường gặp',

    type: 'OneContent\\Page\\Models\\Page',
    referenceId: 21,

    target: '_self',
    parentId: 596,
    lft: 849,
    rgt: 850,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.843000Z',
    updatedAt: '2021-12-06T09:29:09.863000Z',
    reference: {
      slug: 'cau-hoi-thuong-gap',
    },
  },
  {
    id: 603,
    menuId: 3,
    title: 'Tin tức',

    type: 'custom_link',

    target: '_self',
    parentId: 2,
    lft: 852,
    rgt: 883,
    depth: 1,
    createdAt: '2021-12-06T09:29:09.870000Z',
    updatedAt: '2021-12-06T09:29:10.343000Z',
  },
  {
    id: 604,
    menuId: 3,
    title: 'Công bố thông tin',

    type: 'custom_link',

    target: '_self',
    parentId: 603,
    lft: 853,
    rgt: 860,
    depth: 2,
    createdAt: '2021-12-06T09:29:09.903000Z',
    updatedAt: '2021-12-06T09:29:09.997000Z',
  },
  {
    id: 605,
    menuId: 3,
    title: 'Thông báo VCBS',

    type: 'custom_link',

    target: '_self',
    parentId: 604,
    lft: 854,
    rgt: 855,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.937000Z',
    updatedAt: '2021-12-06T09:29:09.960000Z',
  },
  {
    id: 606,
    menuId: 3,
    title: 'Tin quản lý sổ cổ đông',

    type: 'custom_link',

    target: '_self',
    parentId: 604,
    lft: 856,
    rgt: 857,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.963000Z',
    updatedAt: '2021-12-06T09:29:09.990000Z',
  },
  {
    id: 607,
    menuId: 3,
    title: 'Tin tức đấu giá',

    type: 'custom_link',

    target: '_self',
    parentId: 604,
    lft: 858,
    rgt: 859,
    depth: 3,
    createdAt: '2021-12-06T09:29:09.993000Z',
    updatedAt: '2021-12-06T09:29:10.023000Z',
  },
  {
    id: 608,
    menuId: 3,
    title: 'Tin tức và sự kiện VCBS',

    type: 'custom_link',

    target: '_self',
    parentId: 603,
    lft: 861,
    rgt: 862,
    depth: 2,
    createdAt: '2021-12-06T09:29:10.030000Z',
    updatedAt: '2021-12-06T09:29:10.057000Z',
  },
  {
    id: 609,
    menuId: 3,
    title: 'Báo cáo VCBS',

    type: 'custom_link',

    target: '_self',
    parentId: 603,
    lft: 863,
    rgt: 870,
    depth: 2,
    createdAt: '2021-12-06T09:29:10.067000Z',
    updatedAt: '2021-12-06T09:29:10.180000Z',
  },
  {
    id: 610,
    menuId: 3,
    title: 'Báo cáo tài chính',

    type: 'custom_link',

    target: '_self',
    parentId: 609,
    lft: 864,
    rgt: 865,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.103000Z',
    updatedAt: '2021-12-06T09:29:10.137000Z',
  },
  {
    id: 611,
    menuId: 3,
    title: 'Báo cáo thường niên',

    type: 'custom_link',

    target: '_self',
    parentId: 609,
    lft: 866,
    rgt: 867,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.143000Z',
    updatedAt: '2021-12-06T09:29:10.173000Z',
  },
  {
    id: 612,
    menuId: 3,
    title: 'Báo cáo tình hình quản trị công ty',

    type: 'custom_link',

    target: '_self',
    parentId: 609,
    lft: 868,
    rgt: 869,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.177000Z',
    updatedAt: '2021-12-06T09:29:10.200000Z',
  },
  {
    id: 613,
    menuId: 3,
    title: 'Tin tức SGDCK',

    type: 'custom_link',

    target: '_self',
    parentId: 603,
    lft: 871,
    rgt: 880,
    depth: 2,
    createdAt: '2021-12-06T09:29:10.203000Z',
    updatedAt: '2021-12-06T09:29:10.320000Z',
  },
  {
    id: 614,
    menuId: 3,
    title: 'Tin SGD Hồ Chí Minh',

    type: 'custom_link',

    target: '_self',
    parentId: 613,
    lft: 872,
    rgt: 873,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.233000Z',
    updatedAt: '2021-12-06T09:29:10.260000Z',
  },
  {
    id: 615,
    menuId: 3,
    title: 'Tin SGD Hà Nội',

    type: 'custom_link',

    target: '_self',
    parentId: 613,
    lft: 874,
    rgt: 875,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.263000Z',
    updatedAt: '2021-12-06T09:29:10.287000Z',
  },
  {
    id: 616,
    menuId: 3,
    title: 'Tin UPCOM',

    type: 'custom_link',

    target: '_self',
    parentId: 613,
    lft: 876,
    rgt: 877,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.290000Z',
    updatedAt: '2021-12-06T09:29:10.310000Z',
  },
  {
    id: 617,
    menuId: 3,
    title: 'Lịch sự kiện',

    type: 'custom_link',

    target: '_self',
    parentId: 613,
    lft: 878,
    rgt: 879,
    depth: 3,
    createdAt: '2021-12-06T09:29:10.317000Z',
    updatedAt: '2021-12-06T09:29:10.333000Z',
  },
  {
    id: 618,
    menuId: 3,
    title: 'Video',

    type: 'custom_link',

    target: '_self',
    parentId: 603,
    lft: 881,
    rgt: 882,
    depth: 2,
    createdAt: '2021-12-06T09:29:10.337000Z',
    updatedAt: '2021-12-06T09:29:10.357000Z',
  },
];

export const notifyData = [
  {
    name: 'VN-Index',
    originNumber: 1365.99,
    movementNumber: 3.17,
    movementPercent: 0.23,
    isIncrease: true,
  },
  {
    name: 'VN 30',
    originNumber: 1462.74,
    movementNumber: -1.02,
    movementPercent: -0.03,
    isIncrease: false,
  },
  {
    name: 'HNX-Index',
    originNumber: 370.4,
    movementNumber: 1.93,
    movementPercent: 0.53,
    isIncrease: true,
  },
  {
    name: 'UPCOM',
    originNumber: 97.87,
    movementNumber: 0.43,
    movementPercent: 0.5,
    isIncrease: true,
  },
  {
    name: 'VN-Index',
    originNumber: 1365.99,
    movementNumber: 3.17,
    movementPercent: 0.23,
    isIncrease: true,
  },
  {
    name: 'VN 30',
    originNumber: 1462.74,
    movementNumber: -1.02,
    movementPercent: -0.03,
    isIncrease: false,
  },
  {
    name: 'HNX-Index',
    originNumber: 370.4,
    movementNumber: 1.93,
    movementPercent: 0.53,
    isIncrease: true,
  },
  {
    name: 'UPCOM',
    originNumber: 97.87,
    movementNumber: 0.43,
    movementPercent: 0.5,
    isIncrease: true,
  },
];

export const languageData = [
  {
    id: '1',
    icon: vnFlag,
    value: 'vi',
    label: 'Tiếng Việt',
  },
  {
    id: '2',
    icon: enFlag,
    value: 'en',
    label: 'Tiếng Anh',
  },
];

export const externalPages = [
  {
    id: 3,
    label: 'Đăng Nhập',
    link: '/',
    isAuthLink: true,
  },
];

export default headerData;
